import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 584.409 307.557"
    {...props}
  >
    <defs>
      <style>
        {
          ".digital-catalog-2{fill:#00aeef}.digital-catalog-4{fill:#1eca8a}.digital-catalog-5{fill:#c1c6cb}.digital-catalog-7{fill:#eff0f2}.digital-catalog-8{fill:#7c8bdf}.digital-catalog-9{fill:#f93b3b}.digital-catalog-10{fill:#6fd5ff}.digital-catalog-12{fill:#5b6884}"
        }
      </style>
    </defs>
    <g id="Guides_and_Back" data-name="Guides and Back">
      <path
        d="M24.905 116c21.67-34.51 58.889-50.735 204.6-72.326 141.669-20.992 213.441-30.989 259.33-6.515 12.336 6.579 96.324 51.371 101 138.135 3.482 64.67-38.4 128.451-91.836 149.066-56.034 21.618-85.575-19.357-209.2-53.935-160.565-44.909-254.026-15.866-278.229-71.02C-5.077 163.748 21.051 122.139 24.905 116Z"
        transform="translate(-5.623 -22.823)"
      />
      <path
        style={{
          fill: "#fff",
        }}
        d="M44.377 27.177h500v250h-500z"
      />
    </g>
    <g id="Page_Content" data-name="Page Content">
      <path
        className="digital-catalog-2"
        d="M161.72 68.992a3.217 3.217 0 0 1 3.231 3.192v15.771a3.216 3.216 0 0 1-3.231 3.191H86.235A3.216 3.216 0 0 1 83 87.955V72.184a3.217 3.217 0 0 1 3.231-3.192h75.489m0-.992H86.235A4.222 4.222 0 0 0 82 72.184v15.771a4.222 4.222 0 0 0 4.235 4.184h75.485a4.222 4.222 0 0 0 4.235-4.184V72.184A4.222 4.222 0 0 0 161.72 68ZM249.732 68.992a3.214 3.214 0 0 1 3.229 3.192v15.771a3.213 3.213 0 0 1-3.229 3.191h-75.486a3.213 3.213 0 0 1-3.23-3.191V72.184a3.215 3.215 0 0 1 3.23-3.192h75.486m0-.992h-75.486a4.221 4.221 0 0 0-4.234 4.184v15.771a4.221 4.221 0 0 0 4.234 4.184h75.486a4.222 4.222 0 0 0 4.234-4.184V72.184A4.222 4.222 0 0 0 249.732 68ZM337.743 68.992a3.215 3.215 0 0 1 3.229 3.192v15.771a3.214 3.214 0 0 1-3.23 3.191h-75.485a3.214 3.214 0 0 1-3.229-3.191V72.184a3.215 3.215 0 0 1 3.229-3.192h75.486m0-.992h-75.486a4.221 4.221 0 0 0-4.233 4.184v15.771a4.221 4.221 0 0 0 4.233 4.184h75.486a4.221 4.221 0 0 0 4.234-4.184V72.184A4.221 4.221 0 0 0 337.743 68ZM425.755 68.992a3.216 3.216 0 0 1 3.23 3.192v15.771a3.214 3.214 0 0 1-3.23 3.191h-75.486a3.214 3.214 0 0 1-3.23-3.191V72.184a3.216 3.216 0 0 1 3.23-3.192h75.486m0-.992h-75.486a4.222 4.222 0 0 0-4.235 4.184v15.771a4.222 4.222 0 0 0 4.235 4.184h75.486a4.222 4.222 0 0 0 4.234-4.184V72.184A4.222 4.222 0 0 0 425.755 68ZM513.766 68.992A3.216 3.216 0 0 1 517 72.184v15.771a3.215 3.215 0 0 1-3.23 3.191h-75.49a3.215 3.215 0 0 1-3.23-3.191V72.184a3.216 3.216 0 0 1 3.23-3.192h75.486m0-.992H438.28a4.222 4.222 0 0 0-4.234 4.184v15.771a4.222 4.222 0 0 0 4.234 4.184h75.486A4.222 4.222 0 0 0 518 87.955V72.184A4.222 4.222 0 0 0 513.766 68Z"
        transform="translate(-5.623 -22.823)"
      />
      <path
        d="M439.661 100.709h24.2a3.993 3.993 0 0 1 4.017 3.969v16.2a3.994 3.994 0 0 1-4.017 3.97h-24.2a4 4 0 0 1-4.018-3.97v-16.2a3.994 3.994 0 0 1 4.018-3.969Z"
        transform="translate(-5.623 -22.823)"
        style={{
          fill: "#e8e8ea",
        }}
      />
      <path
        className="digital-catalog-4"
        d="M402.41 100.709h24.2a3.994 3.994 0 0 1 4.018 3.969v16.2a4 4 0 0 1-4.018 3.97h-24.2a3.994 3.994 0 0 1-4.017-3.97v-16.2a3.993 3.993 0 0 1 4.017-3.969Z"
        transform="translate(-5.623 -22.823)"
      />
      <path
        className="digital-catalog-2"
        d="M476.911 100.709h37.071a3.994 3.994 0 0 1 4.018 3.969v16.2a4 4 0 0 1-4.018 3.97h-37.071a4 4 0 0 1-4.018-3.97v-16.2a3.994 3.994 0 0 1 4.018-3.969ZM153.45 83.342l-3.637-3.593a.625.625 0 0 1 0-.892l.6-.595a.644.644 0 0 1 .9 0l2.58 2.544 2.58-2.548a.646.646 0 0 1 .9 0l.6.595a.626.626 0 0 1 0 .893l-3.636 3.594a.644.644 0 0 1-.9 0h-.006ZM195.72 101.992a3.217 3.217 0 0 1 3.231 3.192v15.771a3.216 3.216 0 0 1-3.231 3.191h-75.485a3.216 3.216 0 0 1-3.235-3.191v-15.771a3.217 3.217 0 0 1 3.231-3.192h75.489m0-.992h-75.485a4.222 4.222 0 0 0-4.235 4.184v15.771a4.222 4.222 0 0 0 4.235 4.184h75.485a4.222 4.222 0 0 0 4.235-4.184v-15.771A4.222 4.222 0 0 0 195.72 101Z"
        transform="translate(-5.623 -22.823)"
      />
      <path
        className="digital-catalog-2"
        d="m187.45 116.342-3.637-3.593a.625.625 0 0 1 0-.892l.6-.595a.644.644 0 0 1 .9 0l2.58 2.544 2.58-2.548a.646.646 0 0 1 .9 0l.6.595a.626.626 0 0 1 0 .893l-3.636 3.594a.644.644 0 0 1-.9 0h-.006ZM241.206 83.342l-3.636-3.593a.623.623 0 0 1 0-.889l.6-.595a.643.643 0 0 1 .9 0l2.581 2.544 2.581-2.548a.644.644 0 0 1 .9 0l.6.595a.626.626 0 0 1 0 .893l-3.637 3.594a.645.645 0 0 1-.9 0ZM328.962 83.342l-3.636-3.593a.626.626 0 0 1 0-.892l.6-.595a.645.645 0 0 1 .9 0l2.58 2.544L332 78.257a.646.646 0 0 1 .9 0l.6.595a.626.626 0 0 1 0 .893l-3.637 3.594a.644.644 0 0 1-.9 0h-.006ZM504.477 83.342l-3.636-3.593a.623.623 0 0 1 0-.889l.6-.595a.644.644 0 0 1 .9 0l2.581 2.544 2.581-2.548a.644.644 0 0 1 .9 0l.608.595a.627.627 0 0 1 0 .893l-3.637 3.594a.646.646 0 0 1-.9 0ZM416.72 83.342l-3.632-3.6a.624.624 0 0 1 0-.892l.6-.595a.644.644 0 0 1 .9 0l2.58 2.544 2.576-2.544a.646.646 0 0 1 .9 0l.6.595a.625.625 0 0 1 0 .893l-3.636 3.594a.645.645 0 0 1-.9 0Z"
        transform="translate(-5.623 -22.823)"
      />
      <path
        className="digital-catalog-5"
        d="M76.377 86.051h26.5v8.6h-26.5zM218.377 86.051h48v8.6h-48z"
      />
      <path
        d="M213.921 108.236h-7.909a1.078 1.078 0 0 0-1.078 1.078v7.909a1.079 1.079 0 0 0 1.078 1.079h7.909a1.079 1.079 0 0 0 1.079-1.079v-7.909a1.079 1.079 0 0 0-1.079-1.078Zm0 8.987h-7.909v-7.909h7.909Z"
        transform="translate(-5.623 -22.823)"
        style={{
          fill: "#a8a8b1",
        }}
      />
      <circle className="digital-catalog-2" cx={278.377} cy={90.177} r={5} />
      <rect
        className="digital-catalog-7"
        x={76.377}
        y={111.177}
        width={214}
        height={78}
        rx={3.984}
      />
      <rect
        className="digital-catalog-7"
        x={76.377}
        y={197.177}
        width={102}
        height={62}
        rx={3.984}
      />
      <rect
        className="digital-catalog-7"
        x={188.377}
        y={197.177}
        width={102}
        height={62}
        rx={3.984}
      />
      <rect
        className="digital-catalog-8"
        x={82.377}
        y={118.177}
        width={56}
        height={9}
        rx={2.923}
      />
      <rect
        className="digital-catalog-8"
        x={82.377}
        y={137.177}
        width={48}
        height={19}
        rx={2.923}
      />
      <rect
        className="digital-catalog-5"
        x={135.377}
        y={137.177}
        width={59}
        height={19}
        rx={2.923}
      />
      <rect
        className="digital-catalog-5"
        x={82.377}
        y={160.177}
        width={36}
        height={19}
        rx={2.923}
      />
      <rect
        className="digital-catalog-5"
        x={123.377}
        y={160.177}
        width={47}
        height={19}
        rx={2.923}
      />
      <rect
        className="digital-catalog-5"
        x={175.377}
        y={160.177}
        width={58}
        height={19}
        rx={2.923}
      />
      <rect
        className="digital-catalog-5"
        x={199.377}
        y={137.177}
        width={69}
        height={19}
        rx={2.923}
      />
      <rect
        className="digital-catalog-2"
        x={82.377}
        y={203.177}
        width={29}
        height={9}
        rx={2.923}
      />
      <rect
        className="digital-catalog-4"
        x={193.377}
        y={203.177}
        width={44}
        height={9}
        rx={2.923}
      />
      <path className="digital-catalog-4" d="M91.377 246.177h19v7h-19z" />
      <path className="digital-catalog-9" d="M203.377 246.177h19v7h-19z" />
      <rect
        className="digital-catalog-7"
        x={298.377}
        y={111.177}
        width={214}
        height={78}
        rx={3.984}
      />
      <rect
        className="digital-catalog-7"
        x={298.377}
        y={197.177}
        width={214}
        height={62}
        rx={3.984}
      />
      <rect
        className="digital-catalog-10"
        x={304.377}
        y={118.177}
        width={41}
        height={9}
        rx={2.923}
      />
      <rect
        className="digital-catalog-10"
        x={349.377}
        y={136.177}
        width={141}
        height={6}
        rx={2.923}
      />
      <rect
        className="digital-catalog-10"
        x={349.377}
        y={149.177}
        width={73}
        height={6}
        rx={2.923}
      />
      <rect
        className="digital-catalog-10"
        x={349.377}
        y={162.177}
        width={59}
        height={6}
        rx={2.923}
      />
      <rect
        className="digital-catalog-10"
        x={349.377}
        y={175.177}
        width={35}
        height={6}
        rx={2.923}
      />
      <rect
        x={304.377}
        y={203.177}
        width={78}
        height={9}
        rx={2.923}
        style={{
          fill: "#efc621",
        }}
      />
      <path
        className="digital-catalog-5"
        d="M82.377 222.051h35v16.126h-35zM193.377 222.051h35v16.126h-35zM304.377 222.051h57v16.126h-57zM378.377 222.051h48v16.126h-48zM448.377 222.051h55v16.126h-55z"
      />
      <path
        className="digital-catalog-4"
        d="M93.794 270h-1.521a.3.3 0 0 0-.219.521l.418.412q-.861.893-1.72 1.788l-.928-.814a.338.338 0 0 0-.2-.067.332.332 0 0 0-.221.09q-.845.928-1.688 1.859a.188.188 0 0 0-.065.14.173.173 0 0 0 .039.1l.387.369a.169.169 0 0 0 .116.051.179.179 0 0 0 .141-.076l1.328-1.526.9.8a.326.326 0 0 0 .232.076.321.321 0 0 0 .206-.1l2.057-2.116.418.412A.31.31 0 0 0 94 271.7v-1.5a.205.205 0 0 0-.206-.2Z"
        transform="translate(-5.623 -22.823)"
      />
      <path className="digital-catalog-4" d="M457.377 246.177h19v7h-19z" />
      <path
        className="digital-catalog-4"
        d="M459.794 270h-1.521a.3.3 0 0 0-.219.521l.418.412q-.861.893-1.72 1.788l-.928-.814a.338.338 0 0 0-.2-.067.332.332 0 0 0-.221.09q-.844.928-1.688 1.859a.188.188 0 0 0-.065.14.173.173 0 0 0 .039.1l.387.369a.169.169 0 0 0 .116.051.179.179 0 0 0 .141-.076l1.328-1.526.9.8a.326.326 0 0 0 .232.076.321.321 0 0 0 .206-.1l2.057-2.116.418.412a.31.31 0 0 0 .526-.219v-1.5a.205.205 0 0 0-.206-.2Z"
        transform="translate(-5.623 -22.823)"
      />
      <path
        className="digital-catalog-9"
        d="M204.794 275h-1.521a.3.3 0 0 1-.219-.521l.418-.412q-.861-.893-1.72-1.788l-.928.814a.338.338 0 0 1-.2.067.332.332 0 0 1-.221-.09q-.844-.928-1.688-1.859a.188.188 0 0 1-.065-.14.173.173 0 0 1 .039-.1l.387-.369a.169.169 0 0 1 .116-.051.179.179 0 0 1 .141.076l1.328 1.526.9-.8a.326.326 0 0 1 .232-.076.321.321 0 0 1 .206.1l2.057 2.116.418-.412a.31.31 0 0 1 .528.216v1.5a.205.205 0 0 1-.208.203Z"
        transform="translate(-5.623 -22.823)"
      />
      <path className="digital-catalog-9" d="M314.377 246.177h19v7h-19z" />
      <path
        className="digital-catalog-9"
        d="M315.794 275h-1.521a.3.3 0 0 1-.219-.521l.418-.412q-.861-.893-1.72-1.788l-.928.814a.338.338 0 0 1-.2.067.332.332 0 0 1-.221-.09q-.844-.928-1.688-1.859a.188.188 0 0 1-.065-.14.173.173 0 0 1 .039-.1l.387-.369a.169.169 0 0 1 .116-.051.179.179 0 0 1 .141.076l1.328 1.526.9-.8a.326.326 0 0 1 .232-.076.321.321 0 0 1 .206.1l2.057 2.116.418-.412a.31.31 0 0 1 .528.216v1.5a.205.205 0 0 1-.208.203Z"
        transform="translate(-5.623 -22.823)"
      />
      <path className="digital-catalog-9" d="M388.377 246.177h19v7h-19z" />
      <path
        className="digital-catalog-9"
        d="M389.794 275h-1.521a.3.3 0 0 1-.219-.521l.418-.412q-.861-.893-1.72-1.788l-.928.814a.338.338 0 0 1-.2.067.332.332 0 0 1-.221-.09q-.844-.928-1.688-1.859a.188.188 0 0 1-.065-.14.173.173 0 0 1 .039-.1l.387-.369a.169.169 0 0 1 .116-.051.179.179 0 0 1 .141.076l1.328 1.526.9-.8a.326.326 0 0 1 .232-.076.321.321 0 0 1 .206.1l2.057 2.116.418-.412a.31.31 0 0 1 .528.216v1.5a.205.205 0 0 1-.208.203Z"
        transform="translate(-5.623 -22.823)"
      />
      <path
        className="digital-catalog-5"
        d="M304.134 134.426h29.243v8.6h-29.243zM494.377 134.426h13v8.6h-13zM494.377 147.426h13v8.6h-13zM494.377 160.426h13v8.6h-13zM494.377 173.426h13v8.6h-13zM304.134 147.426h42.243v8.6h-42.243zM304.134 160.426h33.243v8.6h-33.243zM304.134 173.426h24.243v8.6h-24.243z"
      />
      <path
        className="digital-catalog-12"
        d="M284.54 140.75h3.96a.5.5 0 0 1 .5.5v3.3a.5.5 0 0 1-.5.5h-3.96a.5.5 0 0 1-.5-.5v-3.3a.5.5 0 0 1 .5-.5Zm-1.652 0h-3.964a.5.5 0 0 0-.5.5v3.3a.5.5 0 0 0 .5.5h3.964a.5.5 0 0 0 .5-.5v-3.3a.5.5 0 0 0-.5-.5Zm-4.459 5.451v3.3a.5.5 0 0 0 .5.5h3.964a.5.5 0 0 0 .5-.5v-3.3a.5.5 0 0 0-.5-.5h-3.964a.5.5 0 0 0-.5.499Zm6.111 3.8h3.96a.5.5 0 0 0 .5-.5v-3.3a.5.5 0 0 0-.5-.5h-3.96a.5.5 0 0 0-.5.5v3.3a.5.5 0 0 0 .5.499ZM512.065 148.935l-1.808-1.808a.434.434 0 0 0-.309-.127h-.295a3.771 3.771 0 1 0-.653.653v.3a.434.434 0 0 0 .127.309l1.808 1.808a.435.435 0 0 0 .615 0l.513-.513a.439.439 0 0 0 .002-.622ZM506.679 147a2.322 2.322 0 1 1 2.321-2.321 2.32 2.32 0 0 1-2.321 2.321ZM179.308 230.229a1.354 1.354 0 0 0-.679-1.169v-3.244a.68.68 0 0 0-1.1-.531l-1.8 1.443a5.156 5.156 0 0 1-3.2 1.124h-4.074a1.358 1.358 0 0 0-1.358 1.358v2.037a1.357 1.357 0 0 0 1.358 1.358h.715a5.072 5.072 0 0 0-.047.679 5.374 5.374 0 0 0 .543 2.353.667.667 0 0 0 .6.363h1.576a.675.675 0 0 0 .55-1.074 2.7 2.7 0 0 1-.554-1.642 2.542 2.542 0 0 1 .094-.679h.594a5.139 5.139 0 0 1 3.2 1.125l1.8 1.443a.68.68 0 0 0 1.1-.531V231.4a1.355 1.355 0 0 0 .682-1.171Zm-2.037 3-.7-.56a6.507 6.507 0 0 0-4.052-1.422v-2.037a6.516 6.516 0 0 0 4.052-1.421l.7-.56ZM279.329 228.382a1.29 1.29 0 1 0-1.289-1.289 1.29 1.29 0 0 0 1.289 1.289Zm0 3.548a.894.894 0 0 1 .274-.645l1.453-1.372a.774.774 0 0 1 .113-.072 1.286 1.286 0 0 0-1.2-.814h-1.287a1.29 1.29 0 0 0-1.29 1.289v1.934a.644.644 0 0 0 .645.645v2.579a.644.644 0 0 0 .645.645h1.289a.644.644 0 0 0 .645-.645v-1.942l-1.016-.957a.9.9 0 0 1-.274-.645Zm7.737-3.548a1.29 1.29 0 1 0-1.29-1.289 1.29 1.29 0 0 0 1.29 1.289Zm.645.645h-1.29a1.288 1.288 0 0 0-1.2.814.774.774 0 0 1 .113.072l1.453 1.372a.9.9 0 0 1 .026 1.264.319.319 0 0 1-.026.026l-1.014.957v1.942a.645.645 0 0 0 .645.645h1.29a.644.644 0 0 0 .644-.645V232.9a.644.644 0 0 0 .645-.645v-1.934a1.29 1.29 0 0 0-1.286-1.294Zm-1.362 2.726-1.453-1.372a.241.241 0 0 0-.409.175v.725h-2.579v-.725a.242.242 0 0 0-.409-.175l-1.452 1.372a.249.249 0 0 0 0 .352l1.452 1.372a.241.241 0 0 0 .409-.175v-.729h2.579v.727a.244.244 0 0 0 .24.244.24.24 0 0 0 .167-.067l1.453-1.372a.249.249 0 0 0 .002-.352ZM512.368 231.653h-4.605l3.066 3.066a.314.314 0 0 0 .431.013 4.643 4.643 0 0 0 1.418-2.732.31.31 0 0 0-.31-.345Zm-.307-1.258a4.67 4.67 0 0 0-4.331-4.331.312.312 0 0 0-.326.314v4.343h4.343a.313.313 0 0 0 .314-.326Zm-5.589 1.258v-4.6a.312.312 0 0 0-.345-.313 4.657 4.657 0 0 0-4 4.77 4.716 4.716 0 0 0 4.714 4.5 4.628 4.628 0 0 0 2.625-.854.31.31 0 0 0 .032-.468Z"
        transform="translate(-5.623 -22.823)"
      />
    </g>
  </svg>
)

export default SvgComponent
